import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Knoppie from './Knoppie';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid';
import List from './List';
import Thumb from './Thumb';
import NoImage from '../images/no-image.png';
import useAuth from '../hooks/useAuth';
import { useStockitemsListFetch } from '../hooks/useStockitemsListFetch';

const StockitemsList = () => {
  const auth = useAuth();
  const location = useLocation();
  const from = location.state?.from || "./";
  const { state, loading, error,searchValue, setSearchValue, setIncludeInactive, fetchStockitemsList } = useStockitemsListFetch();
  const observer = useRef();

  console.log(state)
  const lastStockItemRef = useCallback(
    
    
    (node) => {
      console.log("total pages = "+state.total_pages +" and page is " + state.page)
      if (loading || state.stockitems.length >= state.total_results) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          fetchStockitemsList(state.page,searchValue);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, fetchStockitemsList, state.page]
  );

  const username = auth.auth.user.username;
  const access = auth.auth.user.userRole;

  return (
    <>
      <Header username={username} role={access} destination={"StockControl"} />

      {access === "administrator" && (
        <Knoppie destination={`/addNewStockitem`} text={'Add new Stockitem'} clickable={true} from={'../StockitemsList'} />
      )}

      <div className='ListHead'>
        <SearchBar key={1} setSearchValue={setSearchValue} />
        <div>Stock Items {state.stockitems.length}/{state.total_results}</div>
        <ButtonGrid>
          <Knoppie
            text={'Show All'}
            clickable={true}
            dropdown={true}
            switchOn={true}
            callback={() => setIncludeInactive(true)}
          />
          <Knoppie
            text={'Show Active Only'}
            clickable={true}
            dropdown={true}
            switchOn={false}
            callback={() => setIncludeInactive(false)}
          />
          

        </ButtonGrid>
      </div>

      {error && <div>Error loading stock items</div>}

      <List  destination={''}>
        <Thumb name={"Description"} area={"Qty"} />
        {state.stockitems.length > 0 ? (
          state.stockitems.map((item, index) => (
            <div className='SingleEmployee' key={item._id} ref={index === state.stockitems.length - 1 ? lastStockItemRef : null}>
              

              <Thumb
              clickable={true}
              name={item.desc}
              area={item.stockonhand}
              image={item.imageUrl ? item.imageUrl : NoImage}
              root={'stockitem'}
              from={'StockitemsList'}
              id={item._id}
              employeeid={item._id}>

              {access === "administrator" && (
                <Knoppie text={"Delete"} clickable={true} callback={() => console.log("Delete", item._id)} />
              )}
              </Thumb>
              
         
            </div>
          ))
        ) : (
          <div>No Stockitems found.</div>
        )}
      </List>

      {loading && <h1>Loading more items...</h1>}
    </>
  );
};

export default StockitemsList;
